var _excluded = ["marker", "onMarkerClick", "onMapClick", "onDragEnd", "onRightClick", "onZoomChanged", "onMapTypeIdChanged"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReactStreetview from 'react-streetview';
import { LocalityState } from '@domain-group/fe-allhomes-library';
import AllhomesMap from '@domain-group/fe-co-allhomes-map';
import DesktopBlockmap from './desktop-blockmap';
import LandDetails from './land-details';
import LandDetailsDropDown from './land-details-dropdown';
import MapType from '../enums/map-type';
import LandDetailsPanel from './land-details-panel';
import { changeLayerWhenPossible } from './utils';
import * as styles from './tabbed-maps.style';
import * as landDetailsStyles from './land-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TabbedMaps = props => {
  var _useState = useState(props.state === LocalityState.ACT.abbreviation && !props.displayMapOnly ? MapType.LAND_DETAILS.id : MapType.GOOGLE_ROAD_MAP.id),
    _useState2 = _slicedToArray(_useState, 2),
    currentMapId = _useState2[0],
    setCurrentMapId = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOverlay = _useState4[0],
    setSelectedOverlay = _useState4[1];
  var firstInteractionSeen = useRef();
  var landDetailsControl = useRef();
  var landDetailsDropDown = useRef();
  var onInteract = () => {
    if (!firstInteractionSeen.current) {
      props.onMapFirstInteraction();
      firstInteractionSeen.current = true;
    }
  };
  var selectMap = (mapTypeId, updatedOverlay) => {
    var newOverlay = updatedOverlay || selectedOverlay;
    setCurrentMapId(mapTypeId);
    setSelectedOverlay(mapTypeId === MapType.LAND_DETAILS.id ? newOverlay : null);
    if (landDetailsDropDown.current) {
      landDetailsDropDown.current.closeDropDown();
    }
    onInteract();
  };
  var handleTabSelect = mapTypeId => {
    selectMap(mapTypeId);
    if (mapTypeId !== MapType.LAND_DETAILS.id) {
      props.onTabSelect(mapTypeId);
    }
    onInteract();
  };
  var renderTabs = () => {
    if (props.media.mobile) {
      return null;
    }
    var tabs = Object.values(MapType).reduce((result, mapType) => {
      if (mapType.states.includes(props.state) && (!props.displayMapOnly || mapType.displayMapOnly) && mapType.markers.includes(props.listingMapProps.marker)) {
        result.push(mapType);
      }
      return result;
    }, []);
    return tabs.map(mapType => {
      if (mapType.id === MapType.LAND_DETAILS.id) {
        return ___EmotionJSX(LandDetailsDropDown, {
          selected: mapType.id === currentMapId,
          key: mapType.id,
          currentLayer: selectedOverlay,
          enableCheck: currentMapId === MapType.LAND_DETAILS.id,
          onSelect: (layerKey, legendKey) => {
            handleTabSelect(mapType.id);
            onInteract();
            changeLayerWhenPossible({
              layerKey,
              isSchool: legendKey,
              landDetailsControl
            });
          },
          ref: landDetailsDropDown
        });
      }
      return ___EmotionJSX("button", {
        type: "button",
        css: styles.tab({
          isSelected: mapType.id === currentMapId
        }),
        key: mapType.id,
        onClick: () => {
          handleTabSelect(mapType.id);
          onInteract();
        }
      }, mapType.label);
    });
  };
  var renderMap = () => {
    var interactCallback = function interactCallback(callback) {
      onInteract();
      if (callback) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        callback(...args);
      }
    };
    if (currentMapId === MapType.LAND_DETAILS.id && !props.displayMapOnly) {
      return ___EmotionJSX(LandDetails, _extends({
        onOverlaySelect: layerKey => {
          interactCallback(props.onOverlaySelect, layerKey);
          setSelectedOverlay(layerKey);
          if (landDetailsDropDown.current) {
            landDetailsDropDown.current.closeDropDown();
          }
        },
        onInteract: onInteract,
        ref: landDetailsControl,
        blockInfo: props.blockInfo
      }, props.landDetailsConfig));
    }
    if (currentMapId === MapType.STREET_VIEW.id) {
      var streetViewPanoramaOptions = {
        position: {
          lat: props.listingMapProps.coords.lat,
          lng: props.listingMapProps.coords.lng
        },
        pov: {
          heading: 100,
          pitch: 0
        },
        zoom: 1
      };
      return ___EmotionJSX("div", {
        css: styles.streetView({
          mapOnly: props.displayMapOnly
        }),
        className: "allhomes-listing-map__street-view"
      }, ___EmotionJSX(ReactStreetview, {
        apiKey: props.listingMapProps.googleMapsParams.key,
        streetViewPanoramaOptions: streetViewPanoramaOptions
      }));
    }
    var _props$listingMapProp = props.listingMapProps,
      marker = _props$listingMapProp.marker,
      _onMarkerClick = _props$listingMapProp.onMarkerClick,
      _onMapClick = _props$listingMapProp.onMapClick,
      _onDragEnd = _props$listingMapProp.onDragEnd,
      _onRightClick = _props$listingMapProp.onRightClick,
      _onZoomChanged = _props$listingMapProp.onZoomChanged,
      _onMapTypeIdChanged = _props$listingMapProp.onMapTypeIdChanged,
      passThroughProps = _objectWithoutProperties(_props$listingMapProp, _excluded);
    var overrideOptions = {
      mapTypeControl: false,
      streetViewControl: !props.displayMapOnly,
      zoomControl: !props.media.mobile,
      mapTypeId: MapType[currentMapId].mapTypeId
    };
    return ___EmotionJSX(AllhomesMap, _extends({
      css: styles.allhomesMap({
        mapOnly: props.displayMapOnly
      }),
      useBrandedStyles: false,
      marker: marker,
      overrideOptions: overrideOptions,
      onMarkerClick: clickedMarker => interactCallback(_onMarkerClick, clickedMarker),
      onMapClick: () => interactCallback(_onMapClick),
      onDragEnd: () => interactCallback(_onDragEnd),
      onRightClick: () => interactCallback(_onRightClick),
      onZoomChanged: () => interactCallback(_onZoomChanged),
      onMapTypeIdChanged: () => interactCallback(_onMapTypeIdChanged),
      onExpandMapClick: props.onExpandMapClick
    }, passThroughProps));
  };
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.tabsContainer
  }, renderTabs()), renderMap(), currentMapId !== MapType.LAND_DETAILS.id && !props.displayMapOnly && ___EmotionJSX("div", {
    css: landDetailsStyles.bottomSection
  }, props.blockInfo && ___EmotionJSX("div", {
    css: landDetailsStyles.bottomLeftSection
  }, ___EmotionJSX(DesktopBlockmap, props.blockInfo)), ___EmotionJSX("div", {
    css: landDetailsStyles.bottomRightSection
  }, ___EmotionJSX(LandDetailsPanel, {
    disabled: props.state !== LocalityState.ACT.abbreviation,
    onUpdateOverlay: (layerKey, isSchool) => {
      selectMap(MapType.LAND_DETAILS.id, layerKey);
      changeLayerWhenPossible({
        layerKey,
        isSchool,
        landDetailsControl
      });
    }
  }))));
};

// eslint-disable-next-line react/forbid-foreign-prop-types
var _LandDetails$propType = LandDetails.propTypes,
  onOverlaySelect = _LandDetails$propType.onOverlaySelect,
  landDetailsConfigType = _objectWithoutProperties(_LandDetails$propType, ["onOverlaySelect"]);
TabbedMaps.propTypes = {
  landDetailsConfig: PropTypes.shape(landDetailsConfigType),
  listingMapProps: PropTypes.shape({
    marker: PropTypes.string,
    coords: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    }).isRequired,
    onMarkerClick: PropTypes.func,
    onMapClick: PropTypes.func,
    onDragEnd: PropTypes.func,
    onRightClick: PropTypes.func,
    onZoomChanged: PropTypes.func,
    onMapTypeIdChanged: PropTypes.func,
    googleMapsParams: PropTypes.shape({
      key: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  state: PropTypes.string.isRequired,
  onTabSelect: PropTypes.func,
  onOverlaySelect,
  onMapFirstInteraction: PropTypes.func,
  blockInfo: PropTypes.shape(DesktopBlockmap.propTypes),
  displayMapOnly: PropTypes.bool,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  }),
  onExpandMapClick: PropTypes.func
};
TabbedMaps.defaultProps = {
  landDetailsConfig: null,
  onTabSelect: () => {},
  onOverlaySelect: () => {},
  onMapFirstInteraction: () => {},
  blockInfo: null,
  displayMapOnly: false,
  media: {},
  onExpandMapClick: undefined
};
export default TabbedMaps;